import { RootState } from '@checkout/state';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { LoginWrapper, RegisterForm } from '..';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import messages from './../../../i18n/base-en';
import { fetchSelectionRequest, resetErrors, resetNotifications } from './../../../reducers/checkout';
import { MembershipPanel } from './../../presentational';
import * as Styles from './MembershipForms.scss';

interface IOwnProps {}

interface IConnectedProps {
  isFetching: boolean;
  token?: string;
}

interface IConnectetDispatchProps {
  resetErrors: typeof resetErrors;
  resetNotifications: typeof resetNotifications;
  fetchSelectionRequest: typeof fetchSelectionRequest;
}

interface IOwnState {
  active: 'login' | 'register';
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class MembershipForms extends React.Component<Props, IOwnState> {
  state: IOwnState = {
    active: 'login'
  };

  toggle = () => {
    this.setState({
      active: this.state.active === 'login' ? 'register' : 'login'
    }, () => {
      this.props.resetErrors();
      this.props.resetNotifications();
    });
  }

  // Fetch initial data (allow select countries on the drop down countries while registration)
  componentDidMount() {
    if (!this.props.token) {
      this.props.fetchSelectionRequest();
    }
  }

  render() {
    const { isFetching, intl } = this.props;
    const { active } = this.state;
    const { formatMessage } = intl;
    const isLogin = active === 'login';
    const isRegister = active === 'register';

    return (
      <CheckoutContextConfig.Consumer>
        {(checkoutContextConfig => (
          <div className={Styles.forms}>
            <MembershipPanel isActive={isLogin} toggleActive={this.toggle} buttonLabel={formatMessage(messages.membership_continue)} isFetching={isFetching}>
              <LoginWrapper isFolded={!isLogin} />
            </MembershipPanel>
            <MembershipPanel isActive={isRegister} toggleActive={this.toggle} buttonLabel={formatMessage(messages.membership_start)} isFetching={isFetching}>
              <RegisterForm
                isFolded={!isRegister}
                checkoutContextConfig={checkoutContextConfig}
                physicalStores={checkoutContextConfig.modules.membership.customerClubFields.physicalStores}
              />
            </MembershipPanel>
          </div>
      ))}
      </CheckoutContextConfig.Consumer>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      token: state.checkout.token,
      isFetching: state.checkout.isFetching,
    }),
    {
      resetErrors,
      resetNotifications,
      fetchSelectionRequest,
    }
  )
)(MembershipForms);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/MembershipForms/MembershipForms.tsx